import React from 'react';
import { isClickable, resultsLocked, stepperItems } from './steps';
import {
  StepButton,
  StepConnector,
  StepItem,
  StepLabel,
  StepNumber,
  StepperRow,
  StepperScroll,
} from './style';

// tplA 1983: a step before the one on screen is done (white, purple ring and
// label), the one on screen is filled, later ones are grey, whatever the
// server's state for them (it still decides which ones can be clicked).
const toneOf = (index, viewingIndex) => {
  if (index === viewingIndex) return 'viewing';
  if (viewingIndex >= 0 && index < viewingIndex) return 'done';
  return 'open';
};

/**
 * The stepper (tplA 436–446). Access is the server's `exam.steps[].state`
 * (90 #63): LOCKED rows are not clickable, every other row asks the server
 * through onGo(route). On Results the earlier steps are also locked, except
 * Samples on Mark for me (spec §6, tplA 3259; resultsLocked).
 */
export default function ExamStepper({ exam, viewing, onGo }) {
  const items = stepperItems(exam);
  const viewingIndex = items.findIndex((item) => item.route === viewing);
  return (
    <StepperScroll aria-label="Exam steps">
      <StepperRow>
        {items.map((item, index) => {
          const tone = toneOf(index, viewingIndex);
          const isViewing = item.route === viewing;
          const reachable =
            isClickable(item.state) && !resultsLocked(item.route, exam);
          const clickable = reachable && !isViewing;
          return (
            <StepItem key={item.route} data-state={item.state}>
              {index > 0 && <StepConnector aria-hidden="true" />}
              <StepButton
                type="button"
                title={item.label}
                disabled={!clickable}
                aria-current={isViewing ? 'step' : undefined}
                aria-disabled={!reachable || undefined}
                data-testid={`exam-step-${item.route}`}
                onClick={() => clickable && onGo?.(item.route)}
              >
                <StepNumber $tone={tone}>{item.n}</StepNumber>
                <StepLabel $tone={tone} $viewing={isViewing}>
                  {item.label}
                </StepLabel>
              </StepButton>
            </StepItem>
          );
        })}
      </StepperRow>
    </StepperScroll>
  );
}
